export const DAYS_FOR_MESSAGE = 7;
export const NO_IMAGE =
  "https://boodabike.com/wp-content/uploads/2023/03/no-image.jpg";
